<template>
    <div>
      <iocIframe :src="url" frameborder="0" v-if="url"></iocIframe>
    </div>
  </template>
  
  <script>
  import { getCommunityId, getCommunityName,getCommunity } from '@/api/community/communityApi'
  import { getUserId,getUserName } from '@/api/user/userApi'
  import iocIframe from './iocIframe.vue';
  export default {
    name: 'index',
    components: {
      iocIframe
    },
    data() {
      return {
        url:this.$route.path,
        communityName:getCommunityName(),
        curCommunityId:getCommunityId(),
        userName:getUserName(),
        userId:getUserId(),
        community:getCommunity(),
      }
    },
    created() {
      console.log('this.url',this.$route.path)
    },
  }
  </script>